import axiosResiInstance from "../http/axiosResi";
import isBot from "isbot";

export const getListingValuation = async (listingId) => {
    const userAgent = navigator.userAgent;

    if (!userAgent || isBot(userAgent)) {
        return null;
    }

    let valuation = null;

    try {
        const r = await axiosResiInstance.get(
            `/listing-valuation/${listingId}`
        );

        valuation = r.data.valuation;
    } catch (e) {}

    return valuation;
};
